import { Flex, Link, Text, useDetectDeviceSize } from "@wayflyer/flyui";
import React from "react";

import { DisclaimerParagraph, DisclaimerSection, FooterWrapper } from "./disclosure-footer.styles";
import { getDisclosureConfig, type DisclosureFooterProps } from "./disclosure-footer.config";

export const DisclosureFooter: React.FC<DisclosureFooterProps> = ({ disclosureType, apyRate, interestRate }) => {
  const { isMobile } = useDetectDeviceSize();
  const config = getDisclosureConfig(disclosureType, apyRate, interestRate);

  const allLinks = config.groups.flatMap((group) => group.links || []);

  return (
    <FooterWrapper className="full-width-text" data-testid="disclosure-footer">
      <Flex gap="4" align="flex-start" className="constrainWidth" wrap="wrap" direction="column">
        <DisclaimerSection>
          {config.groups.map((group, groupIndex) => (
            <React.Fragment key={groupIndex}>
              <DisclaimerParagraph>
                {group.segments.map((segment, segmentIndex) => (
                  <React.Fragment key={segmentIndex}>
                    <Text size="xs" fullWidth fontStyle={segment.italic ? "italic" : undefined} color="placeholder">
                      {segment.content}
                    </Text>
                  </React.Fragment>
                ))}
              </DisclaimerParagraph>
            </React.Fragment>
          ))}
        </DisclaimerSection>
        {allLinks.length > 0 && (
          <Flex
            gap="6"
            direction={isMobile ? "column" : "row"}
            align={isMobile ? "flex-start" : "flex-end"}
            width="100%"
            justify="space-between"
          >
            <Flex gap="6" direction={isMobile ? "column" : "row"} align={isMobile ? "flex-start" : "flex-end"}>
              {allLinks.map((link, linkIndex) => (
                <Text size="sm" fontWeight="semiBold" key={linkIndex}>
                  <Link external url={link.url}>
                    {link.text}
                  </Link>
                </Text>
              ))}
            </Flex>
            <Text size="sm" fontWeight="semiBold" align="end">
              <Link external url="https://www.wayflyer.com/terms">
                Wayflyer Terms of Service
              </Link>
            </Text>
          </Flex>
        )}
      </Flex>
    </FooterWrapper>
  );
};
